import { branch, compose, renderComponent, renderNothing } from 'recompose';
import ActiveFinancingStep from './ActiveFinancingStep';
import CommissionSplitsStep from './CommissionSplitsStep';
import CreditToCashRatioStep from './CreditToCashRatioStep';
import BarberBankAccountsStep from './BarberBankAccountsStepContainer';
import { ELIGIBILITY_STEPS } from '../../constants';

export default compose(
  branch(
    props => props.stepId === ELIGIBILITY_STEPS.ACTIVE_FINANCING,
    renderComponent(ActiveFinancingStep),
  ),
  branch(
    props => props.stepId === ELIGIBILITY_STEPS.COMMISSION_SPLITS,
    renderComponent(CommissionSplitsStep),
  ),
  branch(
    props => props.stepId === ELIGIBILITY_STEPS.CREDIT_TO_CASH_RATIO,
    renderComponent(CreditToCashRatioStep),
  ),
  branch(
    props => props.stepId === ELIGIBILITY_STEPS.BARBER_BANK_ACCOUNTS,
    renderComponent(BarberBankAccountsStep),
  ),
  renderNothing,
)();
